import React from 'react';
import { RecommendationSliders } from '@xp-utilities/web';
import RecommendationsWrapper from './RecommendationsWrapper';
import { handleOnRecommendedProductClick } from './helpers';
import {
  RecommendationSlidersContainerPropTypes,
  RecommendationSlidersContainerDefaultProps,
} from './props';

export default function RecommendationSlidersContainer({
  clientId,
  placements,
  useGrid,
  isNewQuickviewEnabled = false,
  queryOptions,
}) {
  const onRecommendedProductClick = (...args) => handleOnRecommendedProductClick(
    isNewQuickviewEnabled,
    ...args,
  );

  return (
    <RecommendationsWrapper clientId={clientId}>
      <RecommendationSliders
        placements={placements}
        onProductClick={onRecommendedProductClick}
        useGrid={useGrid}
        queryOptions={queryOptions}
      />
    </RecommendationsWrapper>
  );
}

RecommendationSlidersContainer.propTypes = RecommendationSlidersContainerPropTypes;
RecommendationSlidersContainer.defaultProps = RecommendationSlidersContainerDefaultProps;
